<template>
  <div>
    <div class="row">
      <div class="col-7 col-sm-12 col-md-12 col-lg-7 col-xl-7">
        <TitleBreadcrumb :page="page" />
      </div>
      <div
        class="col-5 col-sm-12 col-md-12 col-lg-5 col-xl-5 d-flex justify-content-end btn-tab-group"
      >
        <div>
          <div class="col-12 d-flex mt-3 justify-content-end ml-3">
            <div class="d-flex mr-2">
              <ActionButton
                variant="outline-success"
                i="fas fa-arrow-circle-left"
                @click="goBack()"
              >
                Regresar
              </ActionButton>
            </div>
            <div v-if="canSave" class="d-flex mr-2 ml-1">
              <ActionButton
                variant="success"
                type="submit"
                i="fas fa-save pr-1"
                @click="save()"
              >
                Guardar
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown-divider mt-2 pb-2 w-100" />
  </div>
</template>

<script>
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import ActionButton from '@/components/common/ActionButton';

export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  components: {
    TitleBreadcrumb,
    ActionButton,
  },
  methods: {
    save() {
      this.$store.dispatch('saveChangesOnForm');
    },
    goBack() {
      this.$router.go(-1);
    },
    onRegister() {},
  },
  computed: {
    canSave() {
      return true;
    },
  },
};
</script>
